import { Fragment, useState } from 'react';
import Loader from '@/components/atoms/Loader';
import { SpeakerWithDetails } from '@/player-config/src/types/speaker-types';
import { getSpeakerImage } from '@/player-config/src/utils/speakerUtils';

export default function AudiogramImage({ activeSpeaker }: { activeSpeaker: SpeakerWithDetails }) {
  const [showLoader, setShowLoader] = useState(true);
  return (
    <Fragment>
      <img
        className="size-full object-cover"
        hidden={showLoader}
        src={getSpeakerImage(activeSpeaker.profile_picture_url)}
        alt={activeSpeaker.first_name}
        onLoad={() => setShowLoader(false)}
      />
      {showLoader && (
        <div className="absolute inset-1/2">
          <Loader />
        </div>
      )}
    </Fragment>
  );
}
